import { FunctionComponent, useCallback } from 'react'
import { DropdownSelect } from '@dxp-module/common'
import { SelectChangeEvent } from '@mui/material/Select'
import { MyAccountWidgetProps } from '../../../model/MyAccountWidgetProps'
import dropdownSelectStyles from './dropdownSelect.styles'

const DropdownSelectWidget: FunctionComponent<MyAccountWidgetProps> = props => {
  const {
    id,
    schema,
    options,
    onChange,
    placeholder,
    label,
    value,
    uiSchema,
    required,
    disabled,
    rawErrors,
  } = props
  const {
    type,
    readOnly,
    disabled: schemaDisabled,
    default: schemaDefault,
  } = schema
  const {
    inputAdornment,
    showDefaultValue,
    props: uiProps,
  } = uiSchema['ui:options'] || {}
  const styles = dropdownSelectStyles()

  const hasErrors = rawErrors && rawErrors.length > 0

  const handleChange = useCallback(
    (e: SelectChangeEvent) => {
      onChange(e.target.value)
    },
    [onChange]
  )

  const optionList = options?.enumOptions

  if (!optionList) {
    return null
  }

  return (
    <DropdownSelect
      type={type as string}
      label={label}
      disabled={readOnly || disabled || schemaDisabled}
      showLabel={!options.inputLabel}
      onChange={handleChange}
      value={value}
      id={id}
      defaultValue={String(schemaDefault)}
      inputAdornment={inputAdornment}
      showDefaultValue={showDefaultValue}
      placeholder={placeholder}
      errorMessage={hasErrors ? rawErrors[0] : undefined}
      required={required}
      classes={styles}
      options={optionList}
      optionSuffix={uiProps?.optionSuffix}
    />
  )
}

export default DropdownSelectWidget
